import AuthButton from "./LoginButton";
import logoNew from "../../assets/Images/VerticalDarkLogo1.svg";
import sat from "../../assets/Images/SATprep1.svg";
import OnboardingBackground from "../../components/ReUsableComponents/OnboardingBackground";

export type EmailVerificationPromptType = {
  title: string;
  description: string;
  children?: React.ReactNode;
  btnLabel: string;
  btnDisable: boolean;
  onClickHandler: () => void;
  icon: React.ReactNode;
  additionalContent?: React.ReactNode;
  img?: React.ReactNode;
};

const EmailVerificationPrompt = ({
  title,
  description,
  children,
  btnLabel,
  btnDisable,
  onClickHandler,
  icon,
  additionalContent,
  img,
}: EmailVerificationPromptType) => {
  return (
    <OnboardingBackground>  
      <div className="flex flex-col justify-center items-center px-10 w-fit bg-satPrepTransWhite p-9 gap-9 rounded-[28px]">
        <div className="flex flex-col items-center w-[720px] justify-between mx-auto">
        <img src={logoNew} className="w-[260px] h-[163px]" alt="FullMarks Logo" />
          <img src={sat} className="w-[211px] h-[68px]"  alt="SATprep Logo" />
        </div>
        <p className="font-bold text-satPrepAccent text-center text-[40px] font-pretendard cursor-pointer">
          {title}
        </p>
        {img && <div>{img}</div>}
        {description.trim() !== "" && (<p className="leading-[21.6px] text-center text-lg w-[100%] text-[#272727]">
          {description}
        </p>)}
        {children}
        {btnLabel.trim() !== "" && (
          <AuthButton
            text={btnLabel}
            icon={icon}
            iconPosition="left"
            onClick={onClickHandler}
            loader={false}
            disabled={btnDisable}
          />
        )}
      </div>
    </OnboardingBackground>
   
  );
};

export default EmailVerificationPrompt;
